export { default } from "./app-filter-chip.component";
export * from "./app-filter-chip.types";
